import VueI18n from '@/i18n/locale'
import env from './utils/env'
// import { filterCity } from './utils';
// import { API } from './services';
// 按钮状态
export const CURRENT_STATUS = {
  PENDING: 1, // 待处理
  PROCCESSING: 2, // 处理中
  DONE: 3, // 已完成
}

// 紧急程度映射
export const ERGENCY_LEVEL = {
  1: VueI18n.t('Gattaran_Feedback__urHD' /** 低 */),
  2: VueI18n.t('Gattaran_Feedback__fRJi' /** 中 */),
  3: VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */),
}

export const createSendFormSchema = that => {
  const prefixUrl = env.get('config').prefixUrl
  const getAuthParams = env.get('config').getAuthParams
  // const timezone = env.get('options').timezone;
  const country = env.get('options').country
  return {
    type: 'object',
    properties: {
      layout: {
        type: 'void',
        'x-component': 'FormLayout',
        'x-component-props': {
          layout: 'vertical',
        },
        properties: {
          // 问题选择组件（替换原来的工单类型）
          questionInfo: {
            type: 'object',
            'x-decorator': 'FormItem',
            'x-decorator-props': {
              colon: false,
            },
            'x-component': 'QuestionSelector',
            'x-component-props': {
              onQuestionChange: category => {
                that.questionCategory = category
              },
            },
          },
          // 详细表单字段（产品需求类和技术bug类才显示）
          detailFields: {
            type: 'void',
            'x-component': 'FormLayout',
            'x-component-props': {
              layout: 'vertical',
            },
            'x-reactions': {
              dependencies: ['questionInfo'],
              fulfill: {
                state: {
                  visible:
                    '{{$deps[0] && ($deps[0].questionCategory === "product" || $deps[0].questionCategory === "tech")}}',
                },
              },
            },
            properties: {
              module: {
                title: VueI18n.t('Gattaran_Feedback__QLll' /** 问题发生的Gattaran功能模块 */),
                required: true,
                'x-decorator': 'FormItem',
                'x-component': 'Cascader',
                'x-reactions': ['{{useAsyncDataSource(doGetModule)}}'],
                'x-component-props': {
                  placeholder: VueI18n.t('Gattaran_Feedback__vYiO' /** 请选择 */),
                },
              },
              level: {
                title: VueI18n.t('Gattaran_Feedback__MQam' /** 紧急程度 */),
                required: true,
                'x-decorator': 'FormItem',
                'x-component': 'Radio.Group',
                enum: [
                  {
                    label: VueI18n.t('Gattaran_Feedback__dOJj' /** 低 */),
                    value: 1,
                  },
                  {
                    label: VueI18n.t('Gattaran_Feedback__cLbb' /** 中 */),
                    value: 2,
                  },
                  {
                    label: VueI18n.t('Gattaran_Feedback__Xbej' /** 高 */),
                    value: 3,
                  },
                ],
                default: 1,
              },
              area: {
                title: VueI18n.t('Gattaran_Feedback__Govn' /** 问题发生的区域 */),
                required: true,
                'x-decorator': 'FormItem',
                'x-component': 'Select',
                'x-reactions': ['{{useAsyncDataSource(doGetArea)}}'],
                default: [country],
                'x-component-props': {
                  placeholder: VueI18n.t('Gattaran_Feedback__vYiO' /** 请选择 */),
                  clearable: true,
                  disabled: true,
                  multiple: true,
                },
              },
              link: {
                title: VueI18n.t('Gattaran_Feedback__zzVL' /** 问题发生的页面链接 */),
                required: true,
                'x-decorator': 'FormItem',
                'x-component': 'Input',
                'x-component-props': {
                  placeholder: VueI18n.t('Gattaran_Feedback__xywA' /** 请输入 */),
                  clearable: true,
                },
              },
              description: {
                title: VueI18n.t('Gattaran_Feedback__bpPs' /** 问题描述 */),
                required: true,
                'x-decorator': 'FormItem',
                'x-component': 'Input.TextArea',
                'x-component-props': {
                  placeholder: VueI18n.t(
                    'Gattaran_Feedback__chUi' /** 请输入问题的详细描述，比如When、How to do、What、How often等 */,
                  ),
                  rows: 5,
                  showWordLimit: true,
                  maxlength: 500,
                },
              },
              picture: {
                title: VueI18n.t(
                  'Gattaran_Feedback__zEDP' /** 图片附件（最多5张，每张不超过5M） */,
                ),
                type: 'array',
                'x-decorator': 'FormItem',
                'x-component': 'Upload',
                'x-component-props': {
                  action: prefixUrl('common.uploadPublicPic'),
                  multiple: true,
                  listType: 'picture-card',
                  headers: getAuthParams(),
                  accept: '.png, .jpg, .svg',
                  name: 'upfile',
                  limit: 5,
                  // 超过五张图片给提示
                  onExceed: () => {
                    that.$message.warning(
                      VueI18n.t('Gattaran_Feedback__ykZG' /** 最多上传5张图片 */),
                    )
                  },
                  beforeUpload: file => {
                    // file.size 是Bytes, 1KB = 1024Bytes, 1M = 1024KB
                    const isLt5M = file.size / 1024 / 1024 <= 5
                    if (!isLt5M) {
                      that.$message.warning(
                        VueI18n.t(
                          'Gattaran_Feedback__zEDP' /** 图片附件（最多5张，每张不超过5M） */,
                        ),
                      )
                      return false
                    }
                  },
                  fileList: [],
                  'on-success': (res, file) => {
                    file.link = res.data
                  },
                },
              },
              attachment: {
                type: 'array',
                title: VueI18n.t(
                  'Gattaran_Feedback__IdvX' /** 其它附件（excel、pdf、word，限1个） */,
                ),
                'x-decorator': 'FormItem',
                'x-component': 'Upload',
                'x-component-props': {
                  action: prefixUrl('common.uploadPublicPic'),
                  textContent: VueI18n.t('Gattaran_Feedback__mVws' /** 上传 */),
                  accept: '.pdf, .docx, .xlsx, .pptx',
                  listType: 'fileList',
                  headers: getAuthParams(),
                  // 指定上传的文件字段名
                  name: 'upfile',
                  limit: 1,
                  // 超过一张图片给提示
                  onExceed: () => {
                    that.$message.warning(
                      VueI18n.t('Gattaran_Feedback__gRVu' /** 最多只能上传1个非图片类型的附件 */),
                    )
                  },
                  fileList: [],
                  onSuccess: (res, file) => {
                    file.link = res.data
                  },
                },
              },
            },
          },
        },
      },
    },
  }
}
export const getQuestionList = () => {
  const getOperationLink = (type = 'default') => {
    const country = env.get('options').country === 'BR' ? 'BR' : 'SSL'
    const dcLink = {
      BR: {
        default:
          'https://im.xiaojukeji.com/channel?uid=391430&token=c29638c5494143d1a79f5cc4e55a8221&id=3303161854455218688',
        store_info_update:
          'https://im.xiaojukeji.com/channel?token=cb81148fa852ead3615df6874176fe3c&uid=391430&id=3492727598905408512',
        leads_management:
          'https://im.xiaojukeji.com/channel?token=cb81148fa852ead3615df6874176fe3c&uid=391430&id=3492727598905408512',
      },
      SSL: {
        default:
          'https://im.xiaojukeji.com/channel?uid=391430&token=0577663eb3882003f143f1ebd20e5c8d&id=1684820484501169408',
        store_info_update:
          'https://im.xiaojukeji.com/channel?uid=391430&token=0577663eb3882003f143f1ebd20e5c8d&id=1684820484501169408',
        leads_management:
          'https://im.xiaojukeji.com/channel?uid=391430&token=0577663eb3882003f143f1ebd20e5c8d&id=1684820484501169408',
      },
    }
    return dcLink[country][type]
  }
  const getOperationQrcode = (type = 'default') => {
    const country = env.get('options').country === 'BR' ? 'BR' : 'SSL'
    const qcCode = {
      BR: {
        default:
          'https://soda-static.didiglobal.com/static/soda_static/soda/fuxi/6cf3771a914ebd8c04cbbe900.png',
        store_info_update:
          'https://soda-static.didiglobal.com/static/soda_static/soda/fuxi/c581d9b73733b3b8dea522000.png',
        leads_management:
          'https://soda-static.didiglobal.com/static/soda_static/soda/fuxi/c581d9b73733b3b8dea522000.png',
      },
      SSL: {
        default:
          'http://soda-static.didiglobal.com/static/soda_static/soda/fuxi/6cf3771a914ebd8c04cbbe901.png',
      },
    }
    return qcCode[country][type] || qcCode[country].default
  }
  return [
    {
      label: VueI18n.t('Gattaran_Feedback_PXop_Eszz' /** 运营协助 */),
      value: 'operation',
      children: [
        {
          value: 'pending_approval',
          label: VueI18n.t('Gattaran_Feedback_UUdB_fdYt' /** 我有一个待审核任务 */),
          dcQrcode: getOperationQrcode(),
          dcLink: getOperationLink(),
        },
        {
          value: 'menu_modification',
          label: VueI18n.t('Gattaran_Feedback_baMd_rUqS' /** 菜单变更请求 */),
          dcQrcode: getOperationQrcode(),
          dcLink: getOperationLink(),
        },
        {
          value: 'feature_help',
          label: VueI18n.t('Gattaran_Feedback_FAZM_REhE' /** 我想知道这个功能怎么用 */),
          dcQrcode: getOperationQrcode(),
          dcLink: getOperationLink(),
        },
        {
          value: 'other_operation',
          label: VueI18n.t('Gattaran_Feedback_NvwL_Uxho' /** 我需要其它运营类支持 */),
          dcQrcode: getOperationQrcode(),
          dcLink: getOperationLink(),
        },
        {
          value: 'store_info_update',
          label: VueI18n.t('Gattaran_Feedback_JvYQ_JyXO' /** 我希望变更店铺/主体信息 */),
          dcQrcode: getOperationQrcode('store_info_update'),
          dcLink: getOperationLink('store_info_update'),
        },
        {
          value: 'leads_management',
          label: VueI18n.t(
            'Gattaran_Feedback_hXFJ_wgsq' /** 商机管理请求（封禁/解封/创建/修改等） */,
          ),
          dcQrcode: getOperationQrcode('leads_management'),
          dcLink: getOperationLink('leads_management'),
        },
      ],
    },
    {
      label: VueI18n.t('Gattaran_Feedback_tIFD_xuzA' /** 产品建议 */),
      value: 'product',
      children: [
        {
          value: 'feature_suggestion',
          ticketType: '4', // requirement 需求类
          label: VueI18n.t('Gattaran_Feedback_LxIv_wsSj' /** 我有个功能需求/建议 */),
        },
        {
          value: 'no_permission',
          ticketType: '2', // 操作查询类
          label: VueI18n.t('Gattaran_Feedback_Uxer_NPzU' /** 我没有这个功能权限 */),
        },
        {
          value: 'wording_error',
          label: VueI18n.t('Gattaran_Feedback_BnWd_kcBd' /** 我发现一个文案错误 */),
          ticketType: '3', // 文案类
        },
      ],
    },
    {
      label: VueI18n.t('Gattaran_Feedback_aLLw_KcWa' /** 技术咨询 */),
      value: 'tech',
      children: [
        {
          value: 'system_bug',
          ticketType: '1', // bug
          label: VueI18n.t('Gattaran_Feedback_jzdw_zMgo' /** 我可能发现了一个技术bug */),
        },
        {
          value: 'tech_assistance',
          ticketType: '2', // 操作查询类
          label: VueI18n.t('Gattaran_Feedback_yoej_DTPb' /** 我需要技术团队的支持 */),
        },
      ],
    },
  ]
}
